export default {
  view: 'View'
}
